module.exports = __webpack_public_path__ + "img/Not-a-monthly-statement.70af1dda.png";